import React, { useState, useEffect } from 'react'
import { message, Tabs } from 'antd'
import FelTable from './components/felTable'
import HeaderPage from '../../components/HeaderPage'
import FelDrawer from './components/felDrawer'
import LoadMoreButton from '../../components/LoadMoreButton'
import felSrc from './felSrc'
import Utils from '../../utils/Utils'
import { FelContingencyIndex } from './felContingencyIndex'
import { FelContingencyResumen } from './felContingencyResumen'

const { TabPane } = Tabs

function Fels() {
  const [activeTab, setActiveTab] = useState('1')
  const [visible, setVisible] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [editDataDrawer, setEditDataDrawer] = useState(null)
  const [fels, setFels] = useState([])
  const [nextPage, setNextPage] = useState('')
  const [existMoreInfo, setExistMoreInfo] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setVisible(false)
    setLoading(true)
    felSrc
      .read('', 5, true, 'desc')
      .then(fels => {
        if (fels === 'Unauthenticated.') {
          throw new Error('Unauthenticated')
        }
        setFels(getFels(fels))
        setExistMoreInfo(fels.data.next_page_url !== null)
        setNextPage(fels.data.next_page_url)
        setLoading(false)
      })
      .catch(e => {
        console.log(e)
        message.error('No se ha podido cargar la información.')
      })
  }, [])

  const loadData = () => {
    setVisible(false)
    setLoading(true)
    felSrc
      .read('', 5)
      .then(fels => {
        if (fels === 'Unauthenticated.') {
          throw new Error('Unauthenticated')
        }
        setFels(getFels(fels))
        setExistMoreInfo(fels.data.next_page_url !== null)
        setNextPage(fels.data.next_page_url)
        setLoading(false)
      })
      .catch(e => {
        console.log(e)
        message.error('No se ha podido cargar la información.')
      })
  }
  
  const showDrawer = () => {
    setVisible(true)
    setEditMode(false)
  }

  const onClose = () => {
    setVisible(false)
  }

  const handlerMoreButton = () => {
    setExistMoreInfo(false)
    if (existMoreInfo) {
      setLoading(true)
      felSrc.felNextPage(nextPage).then(response => {
        setFels(fels.concat(getFels(response)))
        setExistMoreInfo(response.data.next_page_url !== null)
        setNextPage(response.data.next_page_url)
        setLoading(false)
      })
    }
  }

  const getFels = fels => {
    if (fels !== 'Too Many Attempts.') {
      let _fels = fels.data.data || []
      
      return _fels.map((d, i) => ({
        key: d.id,
        fel_id: d.id,
        company_id: d.company_id,
        company_name: d.company !== null && typeof d.company !== 'undefined' ? d.company.name : null,
        company_nit: d.company !== null && typeof d.company !== 'undefined' ? d.company.nit : null,
        usuario: d.usuario,
        afiliacion_iva: d.afiliacion_iva,
        tipo_frase: d.tipo_frase,
        codigo_escenario: d.codigo_escenario,
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const searchText = value => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(value)
    felSrc
      .read(value, 5, excludeChars, 'desc')
      .then(response => {
        setFels(getFels(response))
        setExistMoreInfo(response.data.next_page_url !== null)
        setNextPage(response.data.next_page_url)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        message.error('Error en la busqueda')
      })
  }

  const EditRow = data => {
    setEditDataDrawer(data)
    setVisible(true)
    setEditMode(true)
  }

  const DeleteRow = data => {
    felSrc
      .felDelete(data.fel_id)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
          setLoading(false)
        } else {
          message.success(`La configuración se ha elminado.`)
          loadData()
        }
      })
      .catch(e => {
        console.log(e)
        message.error('Error al eliminar elemento.')
      })
  }

  const onCancelButton = () => {
    setVisible(false)
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      switch (key) {
        case 'phone':
          message.error(res.errors[key][0].replace('phone', 'Teléfono'))
          break
        case 'nit':
          message.error(res.errors[key][0].replace('nit', 'NIT'))
          break
        default:
          message.error(res.errors[key])
          break
      }
      return null
    })
  }

  const onSaveButton = (data, method) => {    
    setLoading(true)
    switch (method) {
      case true:
        felSrc
          .updateFel(data, data.fel_id)
          .then(res => {
            if (res.errors && Object.keys(res.errors)?.length > 0) {
              checkErrors(res)
              setLoading(false)
            } else {
              message.success('Información actualizada.')
              setVisible(false)
              loadData()
            }
          })
          .catch(e => {
            console.log(e)
            message.error('Error al actualizar la información.')
          })
        break
      case false:        
        felSrc
          .saveFel(data)
          .then(res => {
            if (res.errors && Object.keys(res.errors)?.length > 0) {
              checkErrors(res)
              setLoading(false)
            } else {
              message.success('Información creada.')
              setVisible(false)
              loadData()
            }
          })
          .catch(e => {
            console.log(e)
            message.error('Error al actualizar la información.')
            loadData()
          })
        break
      default:
        break
    }
  }

  return (
    <div>
      <HeaderPage
        title={'Facturación GT'}
        titleButton={activeTab === '1' ? 'Nueva configuración' : undefined}
        showDrawer={activeTab === '1' ? showDrawer : undefined}
        permissions={activeTab === '1' ? 2 : undefined}
      />
      <Tabs id={'felsGTTabs'} defaultActiveKey="1" onChange={setActiveTab}>
        <TabPane tab="Configuración" key="1">
          <FelTable
            dataSource={fels}
            loading={loading}
            handlerTextSearch={searchText}
            handlerEditRow={EditRow}
            handlerDeleteRow={DeleteRow}
          />
          <LoadMoreButton handlerButton={handlerMoreButton} moreInfo={existMoreInfo} />
          <FelDrawer
            closable={onClose}
            visible={visible}
            edit={editMode}
            editData={editDataDrawer}
            cancelButton={onCancelButton}
            saveButton={onSaveButton}
          />
        </TabPane>
        <TabPane tab="Contingencias" key="2">
          <FelContingencyIndex />
        </TabPane>
        <TabPane tab="Resumen SAT" key="3">
          <FelContingencyResumen />
        </TabPane>
      </Tabs>
    </div>
  )
}

export default Fels
